import React from "react";

import styles from "./Autofill.module.scss";

export const AutofillPopup: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.autofillPopup} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
